import { render, staticRenderFns } from "./UnprotectedViewHeader.vue?vue&type=template&id=12ba7f6e&scoped=true"
import script from "./UnprotectedViewHeader.vue?vue&type=script&lang=js"
export * from "./UnprotectedViewHeader.vue?vue&type=script&lang=js"
import style0 from "./UnprotectedViewHeader.vue?vue&type=style&index=0&id=12ba7f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba7f6e",
  null
  
)

export default component.exports